import { emailHref, externalUrlHref, phoneHref } from '@nudool/shared';
import { GlobeIcon, MailIcon, PhoneIcon } from 'lucide-react';

import type { DimeCardShellMetaItem } from '../DimeCardShellMeta.js';

type ContactValue = string | null | undefined;

function contactLink(text: string, href: string | null, external = false) {
  if (!href) {
    return text;
  }
  return (
    <a
      href={href}
      className="text-primary underline"
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {text}
    </a>
  );
}

type ContactFields = Readonly<{
  website?: ContactValue;
  email?: ContactValue;
  phone?: ContactValue;
}>;

/** `keepBlank` lists a passed-but-empty field as an empty row (a card then shows Not Set) instead of dropping it, as a header's facts row does. */
export function buildContactMetaItems(
  contact: ContactFields,
  { keepBlank = false }: Readonly<{ keepBlank?: boolean }> = {},
): DimeCardShellMetaItem[] {
  const { website, email, phone } = contact;
  const items: Array<{ field: keyof ContactFields; item: DimeCardShellMetaItem }> = [
    {
      field: 'website',
      item: {
        icon: <GlobeIcon />,
        label: 'Website',
        value: website ? contactLink(website, externalUrlHref(website), true) : null,
      },
    },
    {
      field: 'email',
      item: {
        icon: <MailIcon />,
        label: 'Email',
        value: email ? contactLink(email, emailHref(email)) : null,
      },
    },
    {
      field: 'phone',
      item: {
        icon: <PhoneIcon />,
        label: 'Phone',
        value: phone ? contactLink(phone, phoneHref(phone)) : null,
      },
    },
  ];
  return items
    .filter(({ field, item }) => item.value !== null || (keepBlank && field in contact))
    .map(({ item }) => item);
}
